var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5.5C4.977.5.5 4.977.5 10.5s4.477 10 10 10 10-4.477 10-10c-.006-5.52-4.48-9.994-10-10z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 7.375l-5.75 5.75M7.875 7.375l5.75 5.75",
    stroke: "#fff",
    strokeWidth: 1.438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/check-cross-icon.c68f34ea.svg";
export { SvgCheckCrossIcon as ReactComponent };